import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { FiltersFormMunicipality } from './list/types';
import { SelectOperatorChoice } from 'shell/constants/select-choice-operator';

export const initialValuesMunicipality: FiltersFormMunicipality = {
  name: '',
  istatCode: '',
  nameOperation: SelectOperatorChoice.Equal,
  provinceCode: '',
  fiscalCode: '',
  code: '',
  page: 0,
  rowsPerPage: 10,
  orders: {},
};

const PageMunicipalityListInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesMunicipality}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageMunicipalityListInitializer.displayName = 'Page Municipality List initializer component';

export default PageMunicipalityListInitializer;
